import { styled } from '@mui/material';

export const MessagesContainer = styled('ul')({
  marginTop: 14,
  marginLeft: 34,
});

export const Message = styled('li')({
  fontSize: 16,
});
